module.exports = __webpack_public_path__ + "img/KQ.350971d2.png";